import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import {connect} from 'react-redux'

import CollapsedSection from 'js/components/shared/CollapsedSection'
import fetchSectionData from '../../actions/fetchSectionData'
import {getId} from '../../actions/saveSectionData'
import {SCROLL_TO_EVENT_KEY} from '../../constants'
import scrollTo from 'js/helpers/scrollTo';

import styles from './AccordionItem.module.scss'

const cx = classnames.bind(styles);

const AccordionItem = function ({
  data,
  map,
  info,
  hotelId,
  fetchSectionDataAction,
  className
}) {
  const SectionComponent = map[data.identifier];
  const [isOpened, setIsOpened] = useState(data.isExpanded);
  const [isLoading, setIsLoading] = useState(false);
  const sectionRef = useRef(null);

  const onSectionOpen = async function () {
    setIsOpened(true)

    if (!info) {
      setIsLoading(true)
      await fetchSectionDataAction({
        wid: data.wid,
        sectionId: data.identifier,
        hotelId,
      })
      setIsLoading(false)
    }
  }

  const onSectionClose = function () {
    setIsOpened(false);
  }

  const onScrollToSection = function (e) {
    if (data.id === e.detail.id) {
      setIsOpened(true)
      scrollTo(sectionRef.current, {
        align: 'top',
        offset: -200
      })
    }
  }

  useEffect(() => {
    window.addEventListener(SCROLL_TO_EVENT_KEY, onScrollToSection)

    return function () {
      window.removeEventListener(SCROLL_TO_EVENT_KEY, onScrollToSection)
    }
  }, []);

  return SectionComponent ? (
    <CollapsedSection
      open={isOpened}
      title={(<h3>{data.title}</h3>)}
      className={cx('section', data?.order >=0 && `order-${data.order}`, className)}
      titleClassName={cx('title')}
      aria={{labelMore: data.plusAriaLabel, labelLess: data.minusAriaLabel}}
      onOpen={onSectionOpen}
      onClose={onSectionClose}
      ref={sectionRef}
    >
      <SectionComponent
        className={cx('body')}
        isLoading={isLoading}
        data={data}
        info={info}
      />
    </CollapsedSection>
  ) : null
}

AccordionItem.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    identifier: PropTypes.string.isRequired,
  })
}

export default connect(({
  main: {
    hotelAccordion,
  },
}, {hotelId, data}) => {
  const storeSectionId = getId(hotelId, data.wid)
  return {
    info: hotelAccordion[storeSectionId]
  }
}, {
  fetchSectionDataAction: fetchSectionData,
})(AccordionItem)
